import AppFormControlFileUploadComponentVue from './file-upload/AppFormControlFileUploadComponent.vue';
import AppFormGroupFileUploadComponentVue from './file-upload/AppFormGroupFileUploadComponent.vue';
import AppRouterLinkComponentVue from './router-link/AppRouterLinkComponent.vue';
import AppSectionComponentVue from './section/AppSectionComponent.vue';
import AppSectionRowComponentVue from './section/AppSectionRowComponent.vue';
import AppSectionColComponentVue from './section/AppSectionColComponent.vue';
import AppFieldHintComponentVue from './field-hint/AppFieldHintComponent.vue';
import AppUnreadBerichtenBadgeComponentVue from './unread-berichten-badge/AppUnreadBerichtenBadgeComponent.vue';
import AppAlertComponentVue from './alert/AppAlertComponent.vue';
import AppInfoBadgeComponentVue from './info-badge/AppInfoBadgeComponent.vue';
import AppFormControlTelefoonnummerVue from './telefoonnummer/AppFormControlTelefoonnummer.vue';
import AppFormGroupTelefoonnummerVue from './telefoonnummer/AppFormGroupTelefoonnummer.vue';

export default function AppComponents(Vue: any) {
  Vue.component('app-form-control-file-upload', AppFormControlFileUploadComponentVue);
  Vue.component('app-form-group-file-upload', AppFormGroupFileUploadComponentVue);
  Vue.component('app-router-link', AppRouterLinkComponentVue);
  Vue.component('app-section', AppSectionComponentVue);
  Vue.component('app-section-row', AppSectionRowComponentVue);
  Vue.component('app-section-col', AppSectionColComponentVue);
  Vue.component('app-field-hint', AppFieldHintComponentVue);
  Vue.component('app-unread-berichten-badge', AppUnreadBerichtenBadgeComponentVue);
  Vue.component('app-info-badge', AppInfoBadgeComponentVue);
  Vue.component('app-alert', AppAlertComponentVue);
  Vue.component('app-form-control-telefoonnummer', AppFormControlTelefoonnummerVue);
  Vue.component('app-form-group-telefoonnummer', AppFormGroupTelefoonnummerVue);
}
